import { BaseFontsourceAsset } from "./base";
import { FontsourceDetailItem, FontsourceListItem } from "../types";
import { MediaType } from "../../../types";

export class FontAsset extends BaseFontsourceAsset {
  constructor(item: FontsourceListItem | FontsourceDetailItem, apiBaseUrl: string) {
    super(item, apiBaseUrl);
  }

  getMediaType(): MediaType {
    return MediaType.Font;
  }
}
